import React from 'react';

/** Progresso — barra de avanço com o valor em texto para leitor de tela. valor de 0 a 100. */
export default function Progresso({ valor, rotulo }) {
  const pct = Math.min(100, Math.max(0, Math.round(valor)));
  const concluido = pct === 100;
  return (
    <div
      className={['sj-progresso', concluido ? 'sj-progresso--concluido' : ''].filter(Boolean).join(' ')}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      aria-label={rotulo}
    >
      <div className="sj-progresso__valor" style={{ width: `${pct}%` }} />
    </div>
  );
}
